import { useIsFetching } from '@tanstack/react-query';

export function useIsFetchingV5(filters) {
	return useIsFetching(filters);
}
